import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import { type AxiosResponse } from "axios";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import { TrackModel } from "~~/package/mapper/track/model/TrackModel";
import type TrackFilterResponse from "~~/package/apis/track/response/TrackFilterResponse";
import type TrackResponse from "~~/package/apis/track/response/TrackResponse";
import { PageModel } from "~~/package/mapper/common/model/PageModel";
import type CustomResponse from "~~/package/types/ResponseType";
import { SkillAdvanceType } from "~~/package/mapper/track/model/SkillAdvanceType";
import { TrackStatusType } from "~~/package/mapper/track/model/TrackStatusType";
import { SkillAdvanceMyTrackModel } from "~~/package/mapper/track/model/SkillAdvanceMyTrackModel";

export default class TrackApi {

    protected http: HttpClient;

    constructor(context: ApplicationContextInterface) {
        this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
    }

    public getAdvanceList(filter: string[], page: number, itemSize: number, advanceType: SkillAdvanceType, field?: string): Promise<AxiosResponse<CustomResponse<PageModel<TrackModel>>>> {
        return this.http.get<AxiosResponse<CustomResponse<PageModel<TrackModel>>>>('/v2/track/list', { filters: filter, page, itemSize, trackPath: advanceType, field }, true);
    }

    public getMyAdvanceList(page: number, itemSize: number, lang: string, filter: string[], advanceType: SkillAdvanceType, field?: string, status?: TrackStatusType): Promise<AxiosResponse<CustomResponse<PageModel<SkillAdvanceMyTrackModel>>>> {
        return this.http.get<AxiosResponse<CustomResponse<PageModel<SkillAdvanceMyTrackModel>>>>('/v2/track/list/my', { filters: filter, page, itemSize, trackPath: advanceType, field, status }, true, lang);
    }

    public getTrack(id: number, lang: string): Promise<AxiosResponse<CustomResponse<TrackModel>>> {
        return this.http.get<AxiosResponse<CustomResponse<TrackModel>>>('/v2/track/'+id, undefined, true, lang);
    }

    public startTrack(id: number): Promise<AxiosResponse<CustomResponse<Boolean>>> {
        return this.http.post<AxiosResponse<CustomResponse<Boolean>>,{[key: string]: number}>(`/track/start/${id}`, {id},true);
    }

    public getTrackFilter(includes?: string): Promise<AxiosResponse<CustomResponse<TrackFilterResponse[]>>> {
        return this.http.get<AxiosResponse<CustomResponse<TrackFilterResponse[]>>>('/v2/track/filters', { includes }, true);
    }
}
